import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Wrench, ArrowRight } from 'lucide-react';
import PartCard from './PartCard';
import { PartAPI } from '../mock';

export default function FeaturedParts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    PartAPI.list({ featured: true, limit: 8 })
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (!loading && items.length === 0) return null;

  return (
    <section className="py-20 lg:py-24 bg-[#fafafa]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-black text-white px-3.5 py-1.5 rounded-full text-[11px] tracking-[0.18em] uppercase font-semibold">
              <Wrench size={12} className="text-[#e11d2c]" /> Parts &amp; Accessories
            </div>
            <h2 className="font-display mt-5 text-[36px] sm:text-[48px] lg:text-[56px] font-black leading-[1.02] tracking-tight text-black">
              Genuine parts. <span className="text-[#e11d2c]">Fair prices</span>.
            </h2>
            <p className="mt-4 text-black/60 text-[15px] max-w-lg">
              Service parts, filters, hybrid components, body panels and accessories — sourced for the Japanese imports we trust.
            </p>
          </div>
          <Link to="/parts" className="hidden lg:inline-flex items-center gap-2 text-black font-semibold border-b-2 border-[#e11d2c] pb-1 hover:gap-3 transition-all">
            Shop all parts <ArrowRight size={16} />
          </Link>
        </div>

        {loading ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {Array.from({ length: 4 }).map((_, i) => <div key={i} className="aspect-[4/3] bg-black/5 rounded-2xl animate-pulse" />)}
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {items.slice(0, 8).map(p => <PartCard key={p.id} p={p} />)}
          </div>
        )}

        <div className="mt-10 flex justify-center lg:hidden">
          <Link to="/parts" className="inline-flex items-center gap-2 text-black font-semibold border-b-2 border-[#e11d2c] pb-1 hover:gap-3 transition-all">
            Shop all parts <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
